import {
  DefaultApiGetSessionsRequest,
  DefaultApiIsSessionActiveRequest,
  DefaultApiGetBatchSessionsRequest,
} from '@/api-client/autogenerated';
import { getApiClient } from '@/api-client/api-client';

export const getSessions = async (params: DefaultApiGetSessionsRequest) => {
  return getApiClient()
    .getSessions(params)
    .then((res) => res.data);
};

export const getBatchSessions = async (params: DefaultApiGetBatchSessionsRequest) => {
  return getApiClient()
    .getBatchSessions(params)
    .then((res) => res.data);
};

export const isSessionActive = async (params: DefaultApiIsSessionActiveRequest) => {
  return getApiClient()
    .isSessionActive(params)
    .then((res) => res.data);
};
